export default __webpack_public_path__ + "static/media/mariamImg.7521851d.svg";